import React, { useEffect, useState } from "react";
import { FormikErrors, useFormik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const estiloAbaPlanoPagamento =
  require("./aba-plano-pagamento.module.scss").default;
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import globalMU from "../../../../globalMU";
import {
  PlanoPagamento,
  Carencia,
  ErroPlanoDePagamento,
  NumeroParcelas,
  PlanoPagamentoFormulario,
} from "../../../types/AbaPlanoPagamento";
import { ListarTiposDocumentoEntradaRespostaItem, ObterDadosPlanoPagamentoResposta } from "app/api/classes/OrcamentoApi";
import { Painel } from "app/components/painel/Painel";
import clsx from "clsx";
const estilosRelatorioVertical = require('app/estilos/relatorioVertical.module.scss').default
const estilosTabelas = require('app/estilos/tabelas.module.scss').default
const estilosBotoes = require('app/estilos/botoes.module.scss').default
const estilosFormulario = require('app/estilos/formulario.module.scss').default
const estiloTabela = require('../../../estilos/tabelas.module.scss').default
import * as R from 'ramda'
import { InputNumerico } from "app/components/inputs/InputNumerico";

export type AbaPlanoPagamentoProps = {
  somenteLeitura: boolean
  planoPagamentoFormulario: PlanoPagamentoFormulario;
  planosPagamento: PlanoPagamento[];
  numerosParcelas: NumeroParcelas[];
  diasCarencia: Carencia[];
  nomeDocumentoPlanoPagamento: string;
  orcamentoPlanoPagamento: boolean;
  simularFinanciamento: boolean;
  contrato: ObterDadosPlanoPagamentoResposta["Contrato"]
  entrada: ObterDadosPlanoPagamentoResposta["Entrada"]
  onSimularPreco: () => void;
  onGerarParcela: (planoDePagamento: PlanoPagamentoFormulario) => void;
  onErrorValidacao: (erros: FormikErrors<PlanoPagamentoFormulario>) => void;
  onEditarParcela: (codigoParcela:number) => void;
  onPlanoPagamentoSelecionado: (codigo:string) => void
  onNumeroParcelasSelecionado:(codigo:number) => void
  onDiasCarenciaSelecionado:(codigo:number) => void
  mostrarDadosDeContratoPorPadrao?:boolean
  mostrarBotaoSimularFinanciamento:boolean
  tiposDocumentoEntrada:ListarTiposDocumentoEntradaRespostaItem[]
  onComEntradaEntradaSelecionado: (comEntrada:boolean) => void
  onEditarParcelaEntrada: () => void
  
}

export const AbaPlanoPagamento = (props: AbaPlanoPagamentoProps) => {
  const [validado, setValidado] = useState(false);

  const formik = useFormik({
    initialValues: props.planoPagamentoFormulario ?? {}, 
    onSubmit: (values, {}) => {},
    enableReinitialize: true,
    validate: (values) => {

      const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`

      return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
        CodigoCarencia: globalMU.isNullOrEmptyOrZero(values.CodigoCarencia) ? mensagemObrigatorio("carencia") : undefined,
        CodigoParcela: globalMU.isNullOrEmptyOrZero(values.CodigoParcela) ? mensagemObrigatorio("parcela") : undefined, 
        CodigoPlanoPagamento: globalMU.isNullOrEmptyOrZero(values.CodigoPlanoPagamento) ? mensagemObrigatorio("planoPagamento") : undefined,
        CodigoDocumentoEntrada: R.includes(values.ComEntrada, [false, null, undefined]) ? null : (globalMU.isNullOrEmpty(values.CodigoDocumentoEntrada) ? mensagemObrigatorio("documento entrada") : null)
      } as FormikErrors<PlanoPagamentoFormulario>)

    },
  })

  const exibirDadosContrato = () => globalMU.isNotNullOrEmpty(props.contrato?.Descricao)

  const mostrarDadosEntrada = () => globalMU.isNotNullOrEmpty(props.entrada?.Descricao)

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      ...props.planoPagamentoFormulario,
    })
  },[props.planoPagamentoFormulario])

  const planoPagamentoSelect = <>
    <label>
      Plano de Pagamento
      <span className={estilosFormulario.obrigatorio}>*</span>
    </label>
    <select
      className={`${validado && formik.errors.CodigoPlanoPagamento != undefined ? estilosFormulario.inputComErro : null}`}
      name="CodigoPlanoPagamento"
      value={formik.values.CodigoPlanoPagamento ?? ""}
      multiple={false}
      disabled={props.somenteLeitura}
      onChange={(e) => {
        formik.setFieldValue("CodigoPlanoPagamento", e.target.value)
        props.onPlanoPagamentoSelecionado(e.target.value)
      }}
    >
      <option value="">Selecione</option>

      {(props.planosPagamento ?? []).map((plano) => <option
          key={plano.Codigo}
          value={plano.Codigo}>
          {plano.Nome}
        </option>)}

    </select>
  </>

  const numeroParcelasSelect = <>
    <label>
      Nº de parcelas
      <span className={estilosFormulario.obrigatorio}>*</span>
    </label>

    <select
      className={`${validado && formik.errors.CodigoParcela != undefined ? estilosFormulario.inputComErro : null}`}
      style={{ maxWidth: "100px" }}
      name="CodigoParcela"
      value={formik.values.CodigoParcela ?? ""}
      multiple={false}
      disabled={props.somenteLeitura}
      onChange={(e) => {
        formik.setFieldValue("CodigoParcela", Number(e.target.value))
        props.onNumeroParcelasSelecionado(Number(e.target.value))
      }}
    >
      <option value="">Selecione</option>
      {props.numerosParcelas?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Quantidade}
        </option>
      ))}
    </select>
  </>

  const diasCarenciaSelect = <>
    <label>
      Dias de Carência
      <span className={estilosFormulario.obrigatorio}>*</span>
    </label>
    <select
      className={`${validado && formik.errors.CodigoCarencia != undefined ? estilosFormulario.inputComErro : null}`}
      style={{ maxWidth: "100px" }}
      name="CodigoCarencia"
      value={formik.values.CodigoCarencia ?? ""}
      multiple={false}
      disabled={props.somenteLeitura}
      onChange={(e) => {
        formik.setFieldValue("CodigoCarencia", Number(e.target.value))
        props.onDiasCarenciaSelecionado(Number(e.target.value))
      }}
    >
      <option value="">Selecione</option>
      {props.diasCarencia?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Dias}
        </option>
      ))}
    </select>
  </>

  const comEntradaCheckbox = <>
    <label htmlFor="planodePagamento_ComEntrada" style={{cursor:'pointer'}}>Com Entrada</label>
    <input
      type="checkbox"
      name="ComEntrada"
      id="planodePagamento_ComEntrada"
      checked={formik.values?.ComEntrada ?? false}
      disabled={props.somenteLeitura}
      onChange={(e) => {
        formik.setFieldValue("ComEntrada", e.target.checked)
        props.onComEntradaEntradaSelecionado(e.target.checked)
      }}
    />
  </>

  const botaoGerarParcelas = <>{!props.somenteLeitura &&
    <button
     id="AbaPlanoPagamento_BotaoGerarParcelas"
    className={clsx(estilosBotoes.botaoPrimario, 'no-global-button')}
    onClick={async () => {
      const erros = await formik.validateForm(formik.values)

      if (Object.keys(erros).length == 0) {
        props.onGerarParcela(formik.values)
      } else {
        props.onErrorValidacao(erros)
      }

      setValidado(true)
    }}
  >
    Gerar Parcelas
  </button>}</>

  const botaoSimularFinanciamento = <button 
    id="AbaPlanoPagamento_BotaoSimularFinanciamento"
    className={clsx(estilosBotoes.botaoPrimario, 'no-global-button')} 
    onClick={() => props.onSimularPreco()}>
    Simular Financiamento
  </button>

  const dadosFinanceiraContrato = <>
    {exibirDadosContrato() &&  <div className={clsx(estilosRelatorioVertical.container, "_max-w-md")}>
      <span className={estilosRelatorioVertical.cabecalho}>Financeira</span>
      <span className={estilosRelatorioVertical.dado}>{props.contrato.NomeFinanceira}</span>

      <span className={estilosRelatorioVertical.cabecalho}>TAC</span>
      <span className={estilosRelatorioVertical.dado}>{globalMU.formatarValorNumerico(props.contrato.ValorTAC, 2, true)}</span>

      <span className={estilosRelatorioVertical.cabecalho}>Valor Total</span>
      <span className={estilosRelatorioVertical.dado}>{globalMU.formatarValorNumerico(props.contrato.ValorTotal, 2, true)}</span>
    </div>}
  </>

  const tabelaParcelas = 
  <div className={estiloTabela.containerRolavel}>
  <table className={clsx(estilosTabelas.tabela, "_mt-8 _w-full")}>
    <thead>
      <th className={estilosTabelas.cabecalhoNumerico}>
        Valor
      </th>
      <th className={estilosTabelas.cabecalhoTexto}>
        Vencimento
      </th>
      <th className={estilosTabelas.cabecalhoTexto}>
        Número
      </th>
      <th className={estilosTabelas.cabecalhoTexto}>
        Banco
      </th>
      <th className={estilosTabelas.cabecalhoTexto}>
        Agência
      </th>
      <th className={estilosTabelas.cabecalhoTexto}>
        Conta
      </th>
      <th>

      </th>
    </thead>

    <tbody>
      {(props.contrato?.ParcelasFinanciamento ?? []).map(parcela => <tr key={parcela.NumeroDocumento}>
        <td className={estilosTabelas.dadoNumerico}>
          {globalMU.formatarValorNumerico(parcela.Valor, 2, true)}
        </td>

        <td className={estilosTabelas.dadoTexto}>
          {globalMU.converterDataFormatoENParaPT(parcela.Vencimento)}
        </td>

        <td className={estilosTabelas.dadoTexto}>
          {parcela.NumeroDocumento}
        </td>

        <td className={estilosTabelas.dadoTexto}>
          {parcela.NumeroBanco}
        </td>
        <td className={estilosTabelas.dadoTexto}>
          {parcela.NumeroAgencia}
        </td>
        <td className={estilosTabelas.dadoTexto}>
          {parcela.NumeroConta}
        </td>
        <td>
          <button 
            className={clsx(estilosBotoes.botaoIcone, "no-global-button")}
             id="AbaPlanoPagamento_BotaoEditarParcela"
            onClick={() => props.onEditarParcela(parcela.Codigo)}>
            <FontAwesomeIcon icon={faEdit}/>
          </button>
        </td>
      </tr>)}
    </tbody>
  </table>
  </div>

  const dadosEntrada = <>
    {mostrarDadosEntrada() && <div className={clsx(estilosRelatorioVertical.container, "_max-w-md")}>
        <span className={estilosRelatorioVertical.cabecalho}>Vencimento</span>
        <span className={estilosRelatorioVertical.dado}>{globalMU.converterDataFormatoENParaPT(props.entrada.Vencimento)}</span>

        <span className={estilosRelatorioVertical.cabecalho}>Documento</span>
        <span className={estilosRelatorioVertical.dado}>{props.entrada.NumeroDocumento}</span>

        <span className={estilosRelatorioVertical.cabecalho}>Banco</span>
        <span className={estilosRelatorioVertical.dado}>{props.entrada.NumeroBanco}</span>

        <span className={estilosRelatorioVertical.cabecalho}>Agência</span>
        <span className={estilosRelatorioVertical.dado}>{props.entrada.NumeroAgencia}</span>

        <span className={estilosRelatorioVertical.cabecalho}>Conta</span>
        <span className={estilosRelatorioVertical.dado}>{props.entrada.NumeroConta}</span>
    </div>}
  </>
  

  const painelContrato = <>
    {exibirDadosContrato() && <Painel 
      titulo={`${props.contrato.Descricao}`} 
      mostrarPorPadrao={props.mostrarDadosDeContratoPorPadrao}
      conteudo={<>
        {dadosFinanceiraContrato}

        {tabelaParcelas}
      </>}
      /> }   
    
  </>

  const painelEntrada = <>
    {globalMU.isNotNullOrEmpty(props.entrada?.Descricao) && <Painel
      titulo={`${props.entrada.Descricao}`}
      mostrarPorPadrao={props.mostrarDadosDeContratoPorPadrao}
      conteudo={<>
        {dadosEntrada}
      </>}
      botoesTitulo={[
        {
          nome: "Editar parcela",
          icone: faEdit,
          acao: props.onEditarParcelaEntrada
        }
      ]}/>}
  </>

  const nomeDocumentoPlanoLabel = <>
    <label>Documento Plano</label>
    <span>{props.nomeDocumentoPlanoPagamento}</span>
  </>

  const documentoEntradaSelect = <>
    <label>
      Documento Entrada

      {formik.values.ComEntrada === true && <span className={estilosFormulario.obrigatorio}>*</span>}
    </label>

    <select
      value={(formik.values.CodigoDocumentoEntrada) ?? ""}
      name="CodigoDocumentoEntrada"
      onChange={formik.handleChange}
      >
        <option value="">
          Selecione
        </option>

        {props.tiposDocumentoEntrada.map(tipoDocumento => <option value={tipoDocumento.Codigo} key={tipoDocumento.Codigo}>
          {tipoDocumento.Descricao}
        </option>)}
    </select>
    
  </>

  const valorEntradaInput = <>
    <label>
      Valor entrada
    </label>
    <InputNumerico
      valor={formik.values.ValorEntrada}
      onValorModificado={valor => formik.setFieldValue("ValorEntrada",valor)}/>
  </>

  return (
    <>
      <fieldset>
        <div className={estiloAbaPlanoPagamento.separador}>
          <div
            className={estilosFormulario.formulario}
          >
            {planoPagamentoSelect}
            
            {numeroParcelasSelect}

            {diasCarenciaSelect}

            {nomeDocumentoPlanoLabel}

            {comEntradaCheckbox}

            {formik.values.ComEntrada && <>
              {documentoEntradaSelect}

              {valorEntradaInput}
            </>}

          </div>
        </div>
      </fieldset>
      
      <br />
      
      <div className="_flex _flex-row _gap-4">
        {botaoGerarParcelas}

        {props.mostrarBotaoSimularFinanciamento && botaoSimularFinanciamento}
      </div>
      
      <div className="_mt-4">
        {exibirDadosContrato() && painelContrato}

        {mostrarDadosEntrada() && painelEntrada}
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
  )
};
